import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Images from "../../../assets/images";
import styles from './Work.module.scss';

const projectData = [
  {
    id: 1,
    type: "App",
    projectId: "farmhousehub",
    image: Images.FarmHouseHub,
    title: 'FarmHouseHub - Dual-module app for booking stays and managing farmhouse rentals.',
  },
  {
    id: 2,
    type: "Web",
    projectId: "varn-alluminium",
    image: Images.WebProject1,
    title: 'Varn - Corporate website for India’s leading aluminum extrusion manufacturer.',
  },
  {
    id: 3,
    type: "App",
    projectId: "geniedelivery",
    image: Images.GenieDelivery,
    title: 'GenieDelivery  - A dynamic cross-platform delivery solution for modern Indian consumers.',
  },
  {
    id: 4,
    type: "Web",
    projectId: "addscale",
    image: Images.AddScale2,
    title: 'AddScale - AI-Powered Digital Marketing Platform',
  },
  {
    id: 5,
    type: "App",
    projectId: "onevision",
    image: Images.OneVision2,
    title: `OneVision - A powerful workforce management platform designed for both business managers and employees.`,
  },
  {
    id: 6,
    type: "Web",
    projectId: "teamflow",
    image: Images.TeamFlow,
    title: 'TeamFlow - Collaborative Team Workspace Platform',
  },
];

const Work = () => {
  const navigate = useNavigate();

  const handleRedirect = (project) => {
    if (project.type === "App") {
      navigate(`/recent-project/${project.projectId}`);
    } else if (project.type === "Web") {
      navigate(`/portfolio/${project.projectId}`);
    }
  };

  return (
    <section className={styles.container}>
      <div className={styles.mainContainer}>
        <div className={styles.heading}>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Our Recent <span>Work</span>
          </motion.h2>
        </div>

        <div className={styles.projectSection}>
          <div className={styles.grid}>
            {projectData.map((project, index) => (
              <motion.div
                key={project.id}
                className={styles.card}
                onClick={() => handleRedirect(project)}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                viewport={{ once: true }}
              >
                <div className={styles.imageWrapper}>
                  <img src={project.image} alt={project.title} />
                  <div className={styles.overlay}>
                    <p>{project.title}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Work;
